export const GPAutocompleteApi = "AIzaSyDW4D_e8Or_MKCoz_ZhdF9bB5LiIyifoa4"
export const DetectLanguageApi = "AIzaSyCk9teSLgWqOpbgbpArgnVZH05POrAqDtA"
export const TranslatorApi = "AIzaSyCk9teSLgWqOpbgbpArgnVZH05POrAqDtA"
export const Auth0Domain = "jelly-ride.eu.auth0.com"
export const Auth0ClientId = "Z6bbBmBXhHWAiaQaY0lcrEgAKhVPerD8"
